import './css/offset_content_box.scss';
import './css/offset_content_form.scss';
import './css/offset_content_img_governace.scss';
import './css/offset_content_img.scss';
import './css/offset_content_box_impact.scss';
import './js/root.js';